import { ExperiencePerformanceTypes } from '@atlassian/ufo-experimental';
export const isInitialPageLoad = data => {
  return data.performanceType === ExperiencePerformanceTypes.PageLoad && data.initial === true;
};